import {
  trigger,
  transition,
  animate,
  keyframes,
  style,
} from '@angular/animations';

export const reportDataTable = trigger('reportDataTable', [
  transition('* => details', [
    animate(
      '1s ease-in',
      keyframes([
        style({ opacity: 0, offset: 0 }),
        style({ opacity: 0.5, offset: 0.5 }),
        style({ opacity: 1, offset: 1.0 }),
      ])
    ),
  ]),
]);

export const haltReportChart = trigger('haltReportChart', [
  transition('* => false', [
    animate(
      '1.5s ease-in',
      keyframes([
        style({ opacity: 0, offset: 0 }),
        style({ opacity: 0.2, offset: 0.2 }),
        style({ opacity: 0.4, offset: 0.4 }),
        style({ opacity: 0.6, offset: 0.6 }),
        style({ opacity: 0.8, offset: 0.8 }),
        style({ opacity: 1, offset: 1 }),
      ])
    ),
  ]),
]);

export const reportData = trigger('reportData', [
  transition('* => *', [
    animate(
      '1s ease-in',
      keyframes([
        style({ opacity: 0, transform: 'translateY(-75%)', offset: 0 }),
        style({ opacity: 0.5, transform: 'translateY(35px)', offset: 0.3 }),
        style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
      ])
    ),
  ]),
]);
